

class TpPrices {
    /**
     * @returns {TpPrices} Instance of.
     */
    constructor() {
        if (this._slider) return;

        this._init();
    }

    /**
     * Initializes the TpPrices component by setting up the TnS (tiny-slider) plugin.
     *
     * @returns {void}
     */
    _init() {
        const container = document.querySelector('.pricing-active');

        if (!container) return;

        if (container.classList.contains('tns-slider') || container.parentElement.classList.contains('tns-outer')) {
            const outer = container.closest('.tns-outer') || container.parentElement;

            if (outer && outer.slider) {
                try {
                    outer.slider.destroy();  // destroy if we can access it
                } catch (e) {
                    console.warn('Destroy failed, cleaning manually', e);
                }
            }

            // Manual cleanup: remove all added wrappers/clones (brute force fallback)
            const parent = container.parentElement;

            if (parent && parent !== document.body && parent.classList.contains('tns-outer')) {
                while (container.firstChild) {
                    parent.before(container.firstChild);
                }

                parent.remove();
            }

            const wrappers = container.querySelectorAll('.single-pricing-wrapper');
            const originalCount = 3;

            if (wrappers.length > originalCount) {
                Array.from(wrappers).slice(originalCount).forEach(el => el.remove());
            }
        }

        // Now safely initialize
        this.slider = tns({
            container: '.pricing-active',
            autoplay: false,
            mouseDrag: true,
            gutter: 0,
            nav: false,
            controls: true,
            controlsText: [
                '<i class="lni lni-chevron-left prev"></i>',
                '<i class="lni lni-chevron-right prev"></i>',
            ],
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                992: { items: 1.2 },
                1200: { items: 2 }
            },
            onInit: () => { }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new TpPrices();
});
